import React from 'react';

interface LoadingScreenProps {
  fullScreen?: boolean;
}

export function LoadingScreen({ fullScreen = false }: LoadingScreenProps) {
  const containerClasses = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-background'
    : 'flex items-center justify-center h-96';

  return (
    <div className={containerClasses}>
      <div className="text-center text-foreground">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-foreground mx-auto mb-4"></div>
        <p className="text-foreground">Se încarcă...</p>
      </div>
    </div>
  );
}
